import { useCallback, useEffect, useState ,React } from "react";
import moment from "moment";
import useLanguage from "../../utils/useLanguage";

const WeekHours = ({ data, title }) => {
    const [weekDays, setWeekDays] = useState({});
    const [isOpen, setIsOpen] = useState();
    const {t} = useLanguage();

    const checkIsOpen = useCallback((weekData)=>{

        moment.updateLocale("en", {
            invalidDate: ""
        });
        
        const now = moment();

        const daysOfWeek = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];

        const startOfWeek = moment().startOf('week');

        function getDateTime(dayName, timeStr) {
            const dayIndex = daysOfWeek.indexOf(dayName);
            const dayDate = startOfWeek.clone().add(dayIndex, 'days');
            const timeMoment = moment(timeStr, "hh:mm a");

            return dayDate.set({
                hour: timeMoment.hour(),
                minute: timeMoment.minute(),
                second: 0,
                millisecond: 0
            });
        }

        const openRanges = [];

        for (const [day, times] of Object.entries(weekData)) {
            if (!Array.isArray(times) || times.length === 0) continue;

            for (const { from, to } of times) {
                const fromTime = getDateTime(day, from);
                const toTime = getDateTime(day, to);
                const overnightToTime = toTime.isSameOrBefore(fromTime) ? toTime.clone().add(1, 'day') : toTime;

                openRanges.push({ fromTime, toTime: overnightToTime });
            }
        }

        const openNow = openRanges.some(({ fromTime, toTime }) => now.isBetween(fromTime, toTime, null, '[)'));

        setIsOpen(openNow);
    }, []);

    useEffect(() => {
        const weekData = data?.weekDays;
        const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        ];
        const today = new Date().getDay();
        const sortedWeekDays = {};

        for (let i = 0; i < 7; i++) {
            const day = daysOfWeek[(today + i) % 7];
            sortedWeekDays[day] = weekData[day];
        }

        setWeekDays(sortedWeekDays);
        setWeekDays(Object.keys(weekData).reduce((acc, curr) => {
            let obj = { ...acc}
            if(weekData[curr]) obj = { ...obj, [curr]: weekData[curr]}
            return obj
        }, {}))

        // Check currently business is open
        checkIsOpen(weekData)
        // Check business is open in every second
        const interval = setInterval(()=>checkIsOpen(weekData),1000);
        return ()=>clearInterval(interval)
    }, [checkIsOpen, data]);

  return (<div className="w-full flex flex-col justify-center items-center rounded-[4px] shadow-[1px_6px_30px_rgba(0,31,14,0.05)] p-[10px] mb-[20px]" style={{marginTop: data?.companyLogo !== '' ? '0px' : '20px'}}>
        <div className="flex flex-row justify-start items-center space-x-[8px] xs:space-x-[17px] w-full mb-[10px]">
            <div className="w-[30px] xs:w-[44px] h-[30px] xs:h-[44px] rounded-[4px] bg-[#F9F9F9] flex justify-center items-center rtl:ml-2">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M12 3.5C7.313 3.5 3.5 7.313 3.5 12C3.5 16.687 7.313 20.5 12 20.5C16.687 20.5 20.5 16.687 20.5 12C20.5 7.313 16.687 3.5 12 3.5ZM12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22Z" fill="#767C83"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M15.4311 15.6925C15.3001 15.6925 15.1681 15.6585 15.0471 15.5875L11.2771 13.3385C11.0511 13.2025 10.9111 12.9575 10.9111 12.6935V7.84546C10.9111 7.43146 11.2471 7.09546 11.6611 7.09546C12.0761 7.09546 12.4111 7.43146 12.4111 7.84546V12.2675L15.8161 14.2975C16.1711 14.5105 16.2881 14.9705 16.0761 15.3265C15.9351 15.5615 15.6861 15.6925 15.4311 15.6925Z" fill="#767C83"/>
                </svg>
            </div>
            <p className="font-medium text-[13px] xs:text-base sm:text-xl text-black" style={{fontFamily: `'${data?.font_text}'`}}>{t('business.open_hours')} - <span style={{ color: isOpen ? 'green' : 'red', textAlign: 'left' }}>{weekDays && isOpen ? t('global.open_now') : t('global.closed')}</span></p>
        </div>
        <div className="w-full h-[1px] bg-[#F2F2F2] rounded-full"></div>
        <div className="flex flex-col items-center justify-center text-[10px] xs:text-sm sm:text-base w-full px-[10px] mb-[10px] mt-[20px] space-y-px" id="openingBlock">
            
            {Object.keys(weekDays).map((day, index) => (
                <div className="w-full space-y-px" key={index}>
                    <div className="flex flex-row items-start justify-between w-full" key={index}>
                        <div className="text-black" style={{fontFamily: `'${data?.font_text}'`}}>{weekDays[day].length > 0 || undefined ? t(`business.${day.toLowerCase()}`) + ":" : ""}</div>
                        <div className="flex flex-col space-y-[5px]">
                            {weekDays[day]
                                ? weekDays[day].map(function (item, index) {
                                    return (
                                        <div key={index}>
                                            <p  className="text-[#767C83]" key={index + item.from + item.to} style={{fontFamily: `'${data?.font_text}'`}}>{moment(item.from, "hh:mm a").format("hh:mm a")} -{" "}{moment(item.to, "hh:mm a").format("hh:mm a")}</p>
                                        </div>
                                    );
                                })
                            : ""}
                        </div>
                    </div>
                    {index !== Object.keys(weekDays).length - 1 && weekDays[day].length > 0 && 
                        <div className="w-full h-[1px] bg-[#F2F2F2] rounded-full my-[10px]" style={{marginTop: "10px", marginBottom: "10px"}}></div>
                    }
                </div>
            ))}
        </div>
    </div>
  );
};

export default WeekHours;